import type { FSNode } from '@lved/shared-core';

export const now = (): number => (typeof performance !== 'undefined' ? performance.now() : Date.now());

export const millisecondsToSeconds = (milliseconds: number): number => milliseconds / 1000;

export const formatSeconds = (seconds: number): string => seconds.toFixed(2);

export const normalizeRepoPath = (path: string): string => path.replace(/^\/+/, '').replace(/\/+$/, '');

export const cloneFsNode = (node: FSNode): FSNode => ({
    ...node,
    children: node.children ? node.children.map(cloneFsNode) : undefined
});
